import type { PlayerSinglePayload } from '@/services/quizzes';
import styles from './QuizQuestion.module.scss';

interface SingleQuestionProps {
  payload: PlayerSinglePayload;
  value: string | null;
  onChange: (selectedId: string) => void;
  disabled?: boolean;
  reveal?: { selectedId: string | null };
}

export function SingleQuestion({ payload, value, onChange, disabled, reveal }: SingleQuestionProps) {
  return (
    <ul className={styles.optionList}>
      {payload.options.map((opt) => {
        const selected = value === opt.id;
        let extra = '';
        if (reveal) {
          if (opt.is_correct) extra = styles.optionCorrect ?? '';
          else if (reveal.selectedId === opt.id) extra = styles.optionIncorrect ?? '';
        } else if (selected) {
          extra = styles.optionSelected ?? '';
        }
        return (
          <li key={opt.id}>
            <label className={`${styles.option} ${extra}`}>
              <input
                type="radio"
                name="single"
                value={opt.id}
                checked={selected}
                onChange={() => onChange(opt.id)}
                disabled={disabled}
                style={{ display: 'none' }}
              />
              <span className={`${styles.radio} ${selected ? styles.radioChecked : ''}`} aria-hidden="true" />
              <span className={styles.label}>{opt.text}</span>
            </label>
          </li>
        );
      })}
    </ul>
  );
}
